import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import user from '@/store/modules/user';
import accounts from '@/store/modules/accounts';
import tradingTrials from '@/store/modules/tradingTrials';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    accounts,
    tradingTrials,
  },
  plugins: [createPersistedState({
    paths: ['user.sessId']
  })],
})
